import React from 'react';

export interface StopGradient {
  offset: number;
  stopColor: string;
  stopOpacity?: number;
}

export interface GradientDefProps {
  gradientId: string;
  gradientY1?: number | string;
  stops?: StopGradient[];
}

export const GradientDef = ({
  gradientId,
  gradientY1,
  stops,
}: GradientDefProps) => {
  return (
    <defs>
      <linearGradient id={gradientId} x1="0" x2="0" y1={gradientY1} y2="1">
        {(stops ?? []).map(({ offset, stopColor, stopOpacity }) => (
          <stop
            key={`gradient-${offset}`}
            offset={`${offset}%`}
            style={{ stopColor, stopOpacity }}
          />
        ))}
      </linearGradient>
    </defs>
  );
};
